import { AxiosResponse } from 'axios';
import { appContextDelete, appContextGet, appContextPost } from './httpCommon/appAxios.service';
import { STAFF_MEMBER_ENDPOINTS } from '../constants/apiEndpoints';
import { StandardParams } from '../types/interfaces';
import { StaffMember } from '../types/interfaces/staffMember.interfaces';

export const addStaffMember = (staff: StaffMember | StaffMember[]): Promise<AxiosResponse<any, any>> => {
  return appContextPost(STAFF_MEMBER_ENDPOINTS.STAFF_MEMBERS, staff);
};

export const getStaffMembers = (params?: StandardParams): Promise<AxiosResponse<StaffMember[], any>> => {
  return appContextGet(STAFF_MEMBER_ENDPOINTS.STAFF_MEMBERS, params);
};

export const deleteStaffMember = (staffId: number): Promise<AxiosResponse<{}, any>> => {
  const url = `${STAFF_MEMBER_ENDPOINTS.STAFF_MEMBERS}/${staffId}`;
  return appContextDelete(url);
};
